module.exports = __webpack_public_path__ + "src/img/bus.79ec24a3.svg";